import styled from 'styled-components'

const MaxWidth = styled.div`
  max-width: ${({ theme }) => theme.maxWidth};
  margin: ${({toLeft}) => toLeft ? '0 auto 0 0' : '0 auto'};
`

export default MaxWidth
